import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/state/app.state';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class OutputDetailsService {
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

  constructor(private http: HttpClient, private store: Store<AppState>) { }
  generateRiskWarning(riskwarning) {
     if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get(this.endPoints.getRiskWarnings);
    } else {
      return this.http.post(this.endPoints.getRiskWarnings, riskwarning, { responseType: 'arraybuffer' });
    }
  }
  handleError(err: HttpErrorResponse) {
    if (!(err.error instanceof Error)) {
      // Optional: handle non-client errors
      // this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
    }
  }
  handlePdfDownload(data: any, padsRefNo: string) {
    const file = new Blob([data], { type: 'application/pdf' });
    const nav = window.navigator as any;

    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(file, `Quote ref${padsRefNo}.pdf`);
    } else {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }

    this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
  }
}
